/** Sort text parts ascending (Apple before Xiaomi), number parts descending (17 before 13) */
export function smartNameCompare(a: string, b: string): number {
  const segsA = a.match(/(\d+|\D+)/g) ?? [];
  const segsB = b.match(/(\d+|\D+)/g) ?? [];
  for (let i = 0; i < Math.max(segsA.length, segsB.length); i++) {
    const sa = segsA[i] ?? '';
    const sb = segsB[i] ?? '';
    const na = /^\d+$/.test(sa) ? parseInt(sa) : null;
    const nb = /^\d+$/.test(sb) ? parseInt(sb) : null;
    if (na !== null && nb !== null) {
      if (na !== nb) return nb - na;
    } else {
      const cmp = sa.localeCompare(sb, undefined, { sensitivity: 'base' });
      if (cmp !== 0) return cmp;
    }
  }
  return 0;
}
